export const softSpring = (index?: number, delay = 0.1) => ({
  delay: index !== undefined ? delay * index : undefined,
  type: "spring",
  damping: 20,
  stiffness: 50,
  mass: 1,
});
